import { createUseStyles } from "react-jss";
import type { VetBoatsTheme } from "../../theme";

type Tone = "onDark" | "onLight";

const useStyles = createUseStyles((theme: VetBoatsTheme) => ({
  lockup: { display: "inline-flex", alignItems: "center", gap: 10 },
  // Deliberately a bit taller than the wordmark so the boat reads as the logo.
  boat: { display: "block", height: 46, width: "auto", flexShrink: 0 },
  boatLarge: { height: 58 },
  mark: {
    display: "inline-flex",
    alignItems: "baseline",
    margin: 0,
    fontWeight: 900,
    letterSpacing: -0.8,
    lineHeight: 1,
    whiteSpace: "nowrap",
  },
  medium: { fontSize: 28, [theme.narrow]: { fontSize: 24 } },
  large: { fontSize: 36 },
  onDark: { color: "#ffffff" },
  onLight: { color: theme.color.primary },
  accent: { color: theme.color.accent },
}));

interface BrandMarkProps {
  tone: Tone;
  size?: "medium" | "large";
  as?: "span" | "h1";
}

/** The drift boat logo followed by the "VetBoats" wordmark ("Boats" in the accent color). */
export const BrandMark = ({
  tone,
  size = "medium",
  as: Tag = "span",
}: BrandMarkProps) => {
  const classes = useStyles();
  return (
    <span className={classes.lockup}>
      <img
        className={`${classes.boat} ${size === "large" ? classes.boatLarge : ""}`}
        src="/vb_logo.svg"
        alt=""
        aria-hidden
        draggable={false}
      />
      <Tag className={`${classes.mark} ${classes[size]} ${classes[tone]}`}>
        Vet<span className={classes.accent}>Boats</span>
      </Tag>
    </span>
  );
};
